import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link as RouterLink } from "react-router-dom";
import type { CreditBalanceResult } from "../messaging/chat.api";

export const ChatHeader = ({ balance }: { balance: CreditBalanceResult | null }) => (
  <Box
    data-tour="chat-header"
    component="header"
    sx={{
      position: "sticky",
      top: 0,
      zIndex: 3,
      display: "grid",
      gridTemplateColumns: "48px minmax(0,1fr) auto",
      alignItems: "stretch",
      minHeight: 64,
      bgcolor: "background.default",
      borderBottom: "1px solid",
      borderColor: "divider",
    }}
  >
    <IconButton
      component={RouterLink}
      to="/chats"
      aria-label="Back to Nikola conversations"
      sx={{ width: 48, minHeight: 48, borderRadius: 0, borderRight: "1px solid", borderColor: "divider" }}
    >
      <ArrowBackIcon />
    </IconButton>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0, px: { xs: 1.25, sm: 2 } }}>
      <Box
        aria-hidden
        data-testid="chat-header-nikola"
        sx={{
          display: "grid",
          placeItems: "center",
          width: 38,
          height: 38,
          bgcolor: "#fff",
          color: "background.default",
          fontSize: 24,
          fontWeight: 900,
        }}
      >
        ♞
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography component="h1" sx={{ fontSize: ".86rem", fontWeight: 900, letterSpacing: ".075em" }}>
          NIKOLA
        </Typography>
        <Typography
          sx={{
            overflow: "hidden",
            color: "text.secondary",
            fontSize: ".56rem",
            fontWeight: 800,
            letterSpacing: ".075em",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          YOUR VERIFIED CHESS COACH
        </Typography>
      </Box>
    </Box>
    <Box
      aria-label={balance ? `${balance.available} Nikola credits available` : "Nikola credits unavailable"}
      sx={{
        display: "grid",
        alignContent: "center",
        justifyItems: "end",
        minWidth: { xs: 68, sm: 100 },
        px: { xs: 1, sm: 2 },
        borderLeft: "1px solid",
        borderColor: "divider",
      }}
    >
      <Typography sx={{ fontSize: { xs: ".72rem", sm: ".82rem" }, fontWeight: 900 }}>
        {balance ? balance.available : "—"}
      </Typography>
      <Typography sx={{ color: "text.secondary", fontSize: ".5rem", fontWeight: 900, letterSpacing: ".08em" }}>
        CREDITS
      </Typography>
    </Box>
  </Box>
);
